// src/pages/OrdenesServicioPrintPage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { obtenerOrden } from "../services/ordenesServicioService";

const money = (n) => n != null ? Number(n).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—";
const fmt = (d) => {
  if (!d) return "";
  return new Date(d).toLocaleDateString("es-MX", { day: "2-digit", month: "long", year: "numeric" });
};
const fmtDt = (d) => {
  if (!d) return "";
  return new Date(d).toLocaleString("es-MX", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export default function OrdenesServicioPrintPage() {
  const { id } = useParams();
  const [orden, setOrden] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    obtenerOrden(id).then(setOrden).catch(() => setError("No se pudo cargar la orden"));
  }, [id]);

  if (error) return <div style={{ padding: 32, color: "red" }}>{error}</div>;
  if (!orden) return <div style={{ padding: 32 }}>Cargando...</div>;

  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; background: white; }
        }
        @media screen {
          body { background: #e5e7eb; }
          .ot-page { box-shadow: 0 4px 24px rgba(0,0,0,.15); }
        }
        .ot-page {
          background: white;
          width: 21cm;
          min-height: 29.7cm;
          margin: 0 auto;
          padding: 1.5cm 1.8cm;
          font-family: Arial, sans-serif;
          font-size: 11pt;
          color: #1e293b;
          box-sizing: border-box;
        }
        .ot-header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 3px solid #1e3a5f; padding-bottom: 14px; margin-bottom: 20px; }
        .ot-title { font-size: 20pt; font-weight: 700; color: #1e3a5f; margin: 0; }
        .ot-folio { font-size: 28pt; font-weight: 900; color: #1e3a5f; text-align: right; }
        .ot-section { margin-bottom: 18px; }
        .ot-section-title { font-size: 9pt; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 1px; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px; margin-bottom: 10px; }
        .ot-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 24px; }
        .ot-field label { font-size: 9pt; color: #64748b; display: block; margin-bottom: 2px; }
        .ot-field span { font-size: 11pt; font-weight: 600; }
        .ot-trabajo { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 14px 16px; font-size: 11pt; line-height: 1.7; white-space: pre-wrap; min-height: 80px; }
        .ot-totales { border: 1px solid #e2e8f0; border-radius: 6px; overflow: hidden; }
        .ot-totales-row { display: flex; justify-content: space-between; padding: 7px 16px; border-bottom: 1px solid #f1f5f9; }
        .ot-totales-row.total { background: #1e3a5f; color: white; font-weight: 700; font-size: 13pt; }
        .ot-firma-box { border: 1px solid #e2e8f0; border-radius: 6px; padding: 12px; min-height: 120px; display: flex; flex-direction: column; align-items: center; justify-content: center; }
        .ot-firma-img { max-height: 110px; max-width: 100%; object-fit: contain; }
        .ot-firma-date { font-size: 9pt; color: #64748b; margin-top: 6px; }
        .ot-firma-empty { border: 2px dashed #cbd5e1; border-radius: 4px; width: 100%; height: 80px; display: flex; align-items: center; justify-content: center; color: #94a3b8; font-size: 10pt; }
        .ot-footer { margin-top: 40px; display: grid; grid-template-columns: 1fr 1fr; gap: 32px; }
        .ot-footer-line { border-top: 1px solid #94a3b8; padding-top: 6px; text-align: center; font-size: 9pt; color: #64748b; }
      `}</style>

      {/* Botones de pantalla */}
      <div className="no-print" style={{ padding: "16px 24px", background: "#f1f5f9", display: "flex", gap: 10, alignItems: "center" }}>
        <button onClick={() => window.print()}
          style={{ padding: "9px 24px", background: "#1e3a5f", color: "white", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 700, fontSize: 14 }}>
          Imprimir / Guardar PDF
        </button>
        <button onClick={() => window.history.back()}
          style={{ padding: "9px 20px", border: "1px solid #cbd5e1", borderRadius: 6, cursor: "pointer", background: "white" }}>
          ← Volver
        </button>
        <span style={{ fontSize: 12, color: "#64748b", marginLeft: 8 }}>
          Para guardar como PDF: en el diálogo de impresión selecciona "Guardar como PDF"
        </span>
      </div>

      <div className="ot-page">
        {/* Encabezado */}
        <div className="ot-header">
          <div>
            <img src="/LMD.jpg" alt="Logo" style={{ height: 50, objectFit: "contain", marginBottom: 6 }}
              onError={e => { e.target.style.display = "none"; }} />
            <div className="ot-title">Orden de Servicio</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4 }}>FOLIO</div>
            <div className="ot-folio">#{orden.ordenTrabajoId}</div>
            <div style={{ fontSize: 10, color: "#64748b", marginTop: 4 }}>
              {orden.status === "A" ? "ABIERTA" : orden.status === "F" ? "FACTURADA" : "CANCELADA"}
            </div>
          </div>
        </div>

        {/* Fechas */}
        <div className="ot-section">
          <div className="ot-section-title">Fechas</div>
          <div className="ot-grid">
            <div className="ot-field">
              <label>Fecha de Entrada</label>
              <span>{fmt(orden.fechaEntrada)}</span>
            </div>
            <div className="ot-field">
              <label>Fecha de Entrega</label>
              <span>{fmt(orden.fechaEntrega)}</span>
            </div>
          </div>
        </div>

        {/* Cliente */}
        <div className="ot-section">
          <div className="ot-section-title">Cliente</div>
          <div className="ot-grid">
            <div className="ot-field">
              <label>Clave</label>
              <span>{orden.cliente}</span>
            </div>
            <div className="ot-field">
              <label>Nombre</label>
              <span>{orden.nombreCliente}</span>
            </div>
            <div className="ot-field" style={{ gridColumn: "1/-1" }}>
              <label>Contacto</label>
              <span>{orden.contacto || "—"}</span>
            </div>
          </div>
        </div>

        {/* Trabajo */}
        <div className="ot-section">
          <div className="ot-section-title">Descripción del Trabajo</div>
          <div className="ot-trabajo">{orden.trabajo}</div>
        </div>

        {/* Totales */}
        {(orden.precioEstimado != null || orden.total != null) && (
          <div className="ot-section" style={{ maxWidth: 320, marginLeft: "auto" }}>
            <div className="ot-section-title">Importe</div>
            <div className="ot-totales">
              <div className="ot-totales-row">
                <span>Subtotal</span>
                <span>${money(orden.precioEstimado)}</span>
              </div>
              <div className="ot-totales-row">
                <span>IVA (16%)</span>
                <span>${money(orden.iva)}</span>
              </div>
              <div className="ot-totales-row total">
                <span>Total</span>
                <span>${money(orden.total)}</span>
              </div>
            </div>
          </div>
        )}

        {/* Firma */}
        <div className="ot-section" style={{ marginTop: 24 }}>
          <div className="ot-section-title">Firma de Conformidad del Cliente</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
            <div>
              <div className="ot-firma-box">
                {orden.firmaImagen
                  ? <>
                      <img src={orden.firmaImagen} alt="Firma del cliente" className="ot-firma-img" />
                      <div className="ot-firma-date">Firmado el: {fmtDt(orden.fechaFirma)}</div>
                    </>
                  : <div className="ot-firma-empty">Sin firma registrada</div>
                }
              </div>
              <div style={{ textAlign: "center", marginTop: 6, fontSize: 10, color: "#64748b" }}>
                Firma del Cliente
              </div>
            </div>
            <div>
              <div className="ot-firma-box" style={{ minHeight: 120 }}>
                <div className="ot-firma-empty"> </div>
              </div>
              <div style={{ textAlign: "center", marginTop: 6, fontSize: 10, color: "#64748b" }}>
                Firma Autorizada / Sello
              </div>
            </div>
          </div>
        </div>

        {/* Nota legal */}
        <div style={{ marginTop: 28, padding: "10px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 9, color: "#64748b", lineHeight: 1.6 }}>
          El cliente acepta que el trabajo descrito en esta orden ha sido revisado y aprobado.
          La firma electrónica capturada tiene la misma validez que una firma autógrafa para efectos de confirmación del servicio.
        </div>
      </div>
    </>
  );
}
